import { addComponentToTree, removeComponentFromTree } from '../Components/ComponentsReducer';
import * as Events from './PagesContextEvents';

export default function pageReducer(state, action) {
    switch (action.type) {
        case Events.SET_PAGES:
            return {
                ...state,
                pages: action.payload.map((folder, folderIndex) => {
                    return {
                        id: folder.id,
                        folderName: folder.folderName,
                        text: folder.folderName,
                        expanded: true,
                        type: "folder",
                        items: folder.pages.sort((a,b) => a.order - b.order).map((page, index) => {
                            return {
                                ...page,
                                text: page.pageName,
                                index: index,
                                treeIndex: `${folderIndex}_${index}` 
                            }
                        })
                    }
                })
            }
        case Events.SELECT_PAGE:
            return {
                ...state,
                selectedPageIndex: action.payload
            }
        case Events.ADD_PAGE: {
            const treeIndex = `${state.selectedPageIndex.split("_")[0]}_${state.pages[state.selectedPageIndex.split("_")[0]].items.length}`
            return {
                ...state,
                selectedPageIndex: treeIndex,
                pages: state.pages.map((folder, index) => {
                    if (folder.id === action.payload.parentId) {
                        return {
                            ...folder,
                            items: [
                                ...folder.items,
                                {
                                    ...action.payload,
                                    _id: action.payload.id,
                                    text: action.payload.pageName,
                                    index: folder.items.length,
                                    treeIndex: `${index}_${folder.items.length}`
                                }
                            ]
                        }
                    }

                    return folder;
                })
            }
        }
        case Events.UPDATE_PAGE: {
            return {
                ...state,
                pages: state.pages.map(folder => {
                    if (folder.id === action.payload.parentId) {
                        return {
                            ...folder,
                            items: folder.items.map(page => {
                                if (page._id === action.payload.pageId) {
                                    return {
                                        ...page,
                                        pageName: action.payload.pageName,
                                        text: action.payload.pageName
                                    }
                                }
                                return page;
                            })
                        }
                    }
                    return folder;
                })
            }
        }
        case Events.DELETE_PAGE: {
            let selectedPageIndex;
            const pages = state.pages.map((folder, fIndex) => {
                if (folder.id === action.payload.parentId) {
                    let pageIndex = folder.items.findIndex(
                        (page) => page._id === action.payload.pageId
                    );
                    if (pageIndex === folder.items.length - 1) {
                        pageIndex--;
                    }
                    if (pageIndex > -1)  {
                        selectedPageIndex = `${fIndex}_${pageIndex}`;
                    }
                    return {
                        ...folder,
                        items: folder.items
                            .filter((page) => {
                                return page._id !== action.payload.pageId;
                            })
                            .map((page, pIndex) => ({
                                ...page,
                                treeIndex: `${fIndex}_${pIndex}`,
                            })),
                    };
                }
                return folder;
            })
            if (!selectedPageIndex) {
                if (pages.length > 1) {
                    let firstAvailablePageIndex;
                    for (let folderIndex = 0; folderIndex < pages.length; folderIndex++) {
                        if (pages[folderIndex] && pages[folderIndex].items && pages[folderIndex].items.length > 0) {
                            firstAvailablePageIndex = `${folderIndex}_0`;
                        }
                    }
                    if (firstAvailablePageIndex) {
                        selectedPageIndex = firstAvailablePageIndex;
                    } else {
                        selectedPageIndex = "0";
                    }
                } else {
                    selectedPageIndex = "0";
                }
            }
            return {
                ...state,
                pages,
                selectedPageIndex
            };
        }
        case Events.REORDER_PAGE: {
            return {
                ...state,
                pages: action.payload
            }
        }
        case Events.TOGGLE_ADD_NEW_PAGE_DIALOG:
            return {
                ...state,
                showAddNewPageDialog: !state.showAddNewPageDialog
            }
        case Events.TOGGLE_EDIT_PAGE_DIALOG:
            return {
                ...state,
                showEditPageDialog: !state.showEditPageDialog,
                editPageIndex: !state.showEditPageDialog ? action.payload : null
            }
        case Events.TOGGLE_DELETE_PAGE_DIALOG:
            return {
                ...state,
                showDeletePageDialog: !state.showDeletePageDialog,
                deletePageIndex: !state.showDeletePageDialog ? action.payload : null
            }
        case Events.TOGGLE_CONTEXT_MENU:
            return {
                ...state,
                showContextMenu: !state.showContextMenu,
                contextMenuOffset: !state.showContextMenu ? action.payload.offset : null,
                contextMenuItemIndex: !state.showContextMenu ? action.payload.index : null
            }
        case Events.UPDATE_PAGE_PROPERTIES:
            return {
                ...state,
                pages: state.pages.map(folder => {
                    if (folder.id === action.payload.parentId) {
                        return {
                            ...folder,
                            items: folder.items.map(page => {
                                if (page._id === action.payload.pageId) {
                                    return {
                                        ...page,
                                        ...action.payload.properties
                                    }
                                }
                                return page;
                            })
                        }
                    }
                    return folder;
                })
            }
        case Events.UPDATE_PAGE_COMPONENT:
            return {
                ...state,
                pages: state.pages.map(folder => {
                    if (folder.id === action.payload.parentId) {
                        return {
                            ...folder,
                            items: folder.items.map(page => {
                                if (page._id === action.payload.pageId) {
                                    return {
                                        ...page,
                                        components: updateComponent(page.components, action.payload.componentId, action.payload.properties)
                                    }
                                }
                                return page;
                            })
                        }
                    }
                    return folder;
                })
            }
        case Events.ADD_COMPONENT_TO_PAGE:
            return {
                ...state,
                pages: state.pages.map(folder => {
                    if (folder.id === action.payload.parentId) {
                        return {
                            ...folder,
                            items: folder.items.map(page => {
                                if (page._id === action.payload.pageId) {
                                    return {
                                        ...page,
                                        components: addComponentToTree(page.components, action.payload.component)
                                    }
                                }
                                return page;
                            })
                        }
                    }
                    return folder;
                })
            }
        case Events.DELETE_COMPONENT:
            return {
                ...state,
                pages: state.pages.map(folder => {
                    if (folder.id === action.payload.parentId) {
                        return {
                            ...folder,
                            items: folder.items.map((page) => {
                                if (page._id === action.payload.pageId) {
                                    const newComponents = removeComponentFromTree(
                                        page.components,
                                        action.payload.componentId
                                    );
                                    return {
                                        ...page,
                                        components: newComponents,
                                    };
                                }
                                return page;
                            }),
                        };
                    }
                    return folder;
                })
            }
        case Events.ADD_COMPONENT_TO_FLATLIST:
            debugger;
            return {
                ...state,
                pages: state.pages.map(folder => {
                    if (folder.id === action.payload.parentId) {
                        return {
                            ...folder,
                            items: folder.items.map(page => {
                                if (page._id === action.payload.pageId) {
                                    debugger;
                                    return {
                                        ...page,
                                        components: [
                                            ...page.components,
                                            action.payload.component
                                        ]
                                    }
                                }
                                return page;
                            })
                        }
                    }
                    return folder;
                })
            }
        default:
            return state;
    }
}

function updateComponent(components, componentId, properties) {
    return components.map(component => {
        if (component.id === componentId) {
            return {
                ...component,
                ...properties
            }
        }
        if (component.components && component.components.length > 0) {
            return {
                ...component,
                components: updateComponent(component.components, componentId, properties)
            }
        } else if (component.children && component.children.length > 0) {
            return {
                ...component,
                children: updateComponent(component.children, componentId, properties)
            }
        }
        return component;
    })
}